import { render, staticRenderFns } from "./AnimationsControl.vue?vue&type=template&id=9d085a64&scoped=true&"
import script from "./AnimationsControl.js?vue&type=script&lang=js&"
export * from "./AnimationsControl.js?vue&type=script&lang=js&"
import style0 from "./AnimationsControl.scss?vue&type=style&index=0&id=9d085a64&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d085a64",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBanner } from 'vuetify/lib/components/VBanner';
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBanner,VBtn})
